// The named lifecycle events (sdk ADR-027).

/** Every failure this feature can report. The name is the log's first field. */
export type LifecycleEventName =
  | 'lifecycle.snapshot_unavailable'
  | 'lifecycle.logout_unbounded'
  | 'lifecycle.logout_unreachable'
  | 'lifecycle.convergence_failed'
  | 'lifecycle.address_unresolved'
  | 'lifecycle.launch_unreadable'
  | 'identity.transition_refused'
  | 'identity.observed_event_dropped'
  | 'identity.bus_message_unsupported'
  | 'identity.frame_malformed'
  | 'identity.credential_unreadable'
  | 'identity.daemon_bearer_unreachable'
  | 'identity.broadcast_unavailable'
  | 'cache.history_revalidate_failed';

export type LifecycleEventFields = Record<string, string | number | boolean | null>;

export interface LifecycleEvent {
  event: LifecycleEventName;
  fields: LifecycleEventFields;
}

/** (sdk ADR-027) */
export type LifecycleObserver = (event: LifecycleEvent) => void;

const consoleObserver: LifecycleObserver = ({ event, fields }) => {
  console.warn(`[${event}]`, JSON.stringify(fields));
};

const subscribers = new Set<{ notify: LifecycleObserver }>();

/** Subscribe a sink. The returned unsubscribe is idempotent and order-free —
 *  two overlapping installers cannot strand each other (sdk ADR-032). */
export function setLifecycleObserver(next: LifecycleObserver): () => void {
  const entry = { notify: next };
  subscribers.add(entry);
  return () => {
    subscribers.delete(entry);
  };
}

export function emitLifecycleEvent(
  event: LifecycleEventName,
  fields: LifecycleEventFields,
): void {
  if (subscribers.size === 0) {
    consoleObserver({ event, fields });
    return;
  }
  for (const entry of [...subscribers]) {
    entry.notify({ event, fields });
  }
}
